import Footer from "../../components/footer";
import Header from "../../components/header";
import NameSection from "../../components/nameSection";
import RememberOldEditions from "../../components/rememberOldEditions";
import CustomVideoPlayer from "../../components/video";
import ScrollingBackground from "../../components/line";
import NextEvents from "../../components/nextEvents";

import {
  Container,
  ContainerAboutUs,
  ContainerEditions,
  ContainerFamilySoccerCamp,
  ContentAboutUs,
  ContentEditions,
  IconArrow,
  TextAboutUs,
  TextSoccerCamp,
} from "./styles";

import ImageArrow from "../../assets/icons/arrow.svg";

const Home = () => {
  return (
    <Container>
      <Header />

      <ContainerFamilySoccerCamp>
        <TextSoccerCamp>
          O <span style={{ color: "#F3B000" }}>Maior</span> Family Soccer Camp
          do mundo.
        </TextSoccerCamp>
        <IconArrow src={ImageArrow} alt="icone_seta" />
      </ContainerFamilySoccerCamp>

      <NextEvents />

      <ContainerAboutUs id="aboutus">
        <ContentAboutUs>
          <CustomVideoPlayer />
          <TextAboutUs>
            <NameSection
              textOne="SOBRE"
              textTwo="NÓS"
              className="NameSection"
            />
            <label>
              Bem-vindo ao{" "}
              <span style={{ color: "#F3B000" }}>Caioba Soccer Camp!</span>
            </label>

            <p>
              "Aqui, transformamos sonhos em realidade através do futebol. Nossa
              missão é unir e fortalecer famílias, promovendo valores como
              respeito, igualdade e espírito de equipe."
            </p>
            <cite>- Caio Ribeiro</cite>
          </TextAboutUs>
        </ContentAboutUs>
      </ContainerAboutUs>

      <ContainerEditions id="timeline">
        <ContentEditions>
          <label>Reviva momentos marcantes das nossas edições passadas.</label>
          <label>
            EXPLORE NOSSA HISTÓRIA COM UMA LINHA DO TEMPO INTERATIVA
          </label>
        </ContentEditions>
        <RememberOldEditions />
      </ContainerEditions>

      <ScrollingBackground />
      <Footer />
    </Container>
  );
};

export default Home;
